import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {AlarmCenter, GetAlarmCentersParams} from 'src/services/api/endpoints/AlarmCenterEndpoint'
import {Paginate} from 'src/services/api/endpoints/_types'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'

type Props = {
  page: number
  pageSize: number
  companyIds: number[]
  search?: GetAlarmCentersParams['search']
  filter?: GetAlarmCentersParams['filter']
  enabled?: boolean
}

const emptyResult: Paginate<AlarmCenter> = {
  totalElements: 0,
  entities: [],
  currentPage: 1,
}

export default function useAlarmCenters({page, pageSize, companyIds, search, filter, enabled = true}: Props) {
  return useQuery({
    enabled: enabled && companyIds.length > 0,
    refetchOnWindowFocus: false,
    retry: false,
    queryKey: [QueryKeyEnum.ALARM_CENTERS, 'list', page, pageSize, companyIds, search, filter],
    queryFn: async () => {
      try {
        const response = await api.alarmCenter.getMany({
          page,
          pageSize,
          search,
          filter: {
            ...filter,
            companyId: companyIds.length === 1 ? companyIds[0] : filter?.companyId,
          },
          orderBy: {createdAt: 'DESC'},
        })

        return response.data.data
      } catch {
        return emptyResult
      }
    },
  })
}
